import {
  type CategorizedResponse,
  LocationQueryEnum,
  ResponseEnum,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";

export const fetchLocations = async (
  search: string,
  callback: (newOptions: any[], fetchedSearch?: string) => void
): Promise<void> => {
  // Don't call the API if there's no search text
  if (!search || search.trim().length === 0) {
    callback([], search);
    return;
  }

  try {
    const results =
      await activitiesApi.apiV0ActivitiesDestinationAutocompletePost({
        query: {
          LocationQuery: LocationQueryEnum.Label,
          l: search,
        },
      });

    if (
      results.status === 499 ||
      results.data.Response !== ResponseEnum.Success
    ) {
      throw new Error("Autocomplete request failed");
    }

    const options: any[] =
      results.data.value.results?.flatMap((categoryRes: CategorizedResponse) =>
        categoryRes.results.map((s) => ({
          ...s,
          category: categoryRes.category,
          categoryLabel: categoryRes.label,
        }))
      ) ?? [];

    callback(options, search);
  } catch (e) {
    console.error("Failed to fetch activity locations:", e);
    callback([], "");
  }
};
